import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { MembreComite } from "../../core/model/membre-comite";
import { MembreComiteService } from "../../core/service/membre-comite.service";

@Component({
  selector: "app-add-membre-comite",
  templateUrl: "./add-membre-comite.component.html",
  styleUrls: ["./add-membre-comite.component.scss"],
})
export class AddMembreComiteComponent implements OnInit {
  membreComite: MembreComite = new MembreComite();

  form2: FormGroup;
  pressButton: Boolean = false;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _membreComiteService: MembreComiteService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      nom: [null, Validators.compose([Validators.required])],
      prenom: [null, Validators.compose([Validators.required])],
      civilite: [null, Validators.compose([Validators.required])],
      entreprise: [null, Validators.compose([Validators.required])],
      poste: [null, Validators.compose([Validators.required])],
      businessEmail: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {}

  save(): void {
    this.pressButton = true;
    this._membreComiteService
      .postMembreComite(this.membreComite)
      .pipe(first())
      .subscribe(
        (data) => {
          this.pressButton = false;
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.pressButton = false;
        }
      );
  }
}
